import { render, staticRenderFns } from "./OurFeatures.vue?vue&type=template&id=ac9f1f7e&scoped=true&"
import script from "./OurFeatures.vue?vue&type=script&lang=js&"
export * from "./OurFeatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac9f1f7e",
  null
  
)

export default component.exports